import { render, staticRenderFns } from "./authSetting.vue?vue&type=template&id=e03c5dc8&scoped=true&"
import script from "./authSetting.vue?vue&type=script&lang=ts&"
export * from "./authSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03c5dc8",
  null
  
)

export default component.exports